<template>
  <div class="echarts-warp">
    <div class="echart-content" ref="pieEcharts">
      <div class="echarts-title" v-if="showTitle">{{ title }}</div>
      <div
        :id="getId"
        style="width:100%;"
        :style="{ height: height + 'px' }"
      ></div>
      <div class="table-wrap" v-if="showTable">
        <template v-if="table.type === 'tab'">
          <div>
            <el-radio-group v-model="radio">
              <el-radio-button
                v-for="(item, index) in table.tabData"
                :key="index"
                :label="item"
              ></el-radio-button>
            </el-radio-group>
          </div>
          <div class="table-content">
            <el-table
              :data="table.data[radio].data"
              border
              style="width: 100%;"
              height="100%"
            >
              <el-table-column
                v-for="(item, index) in table.columns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
              ></el-table-column>
            </el-table>
          </div>
        </template>
        <template v-else>
          <div class="table-content">
            <el-table
              :data="table.data"
              border
              style="width: 100%;"
              height="100%"
            >
              <el-table-column
                v-for="(item, index) in table.columns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
              ></el-table-column>
            </el-table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { number } from "echarts/lib/export";
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "图表标题",
    },
    timeTitle: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    //不规则的x轴
    isIrregularity: {
      type: Boolean,
      default: false,
    },
    showAddBtn: {
      type: Boolean,
      default: false,
    },
    activeName: {
      type: String,
      default: "ele",
    },
    /**
     * 是否显示最大值的点
     */
    showMaxPoint: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否显示最小值的点
     */
    showMinPoint: {
      type: Boolean,
      default: false,
    },
    /**
     * 线   单个图表的时候才起效
     */
    markLine: {
      type: Object,
      default: () => {},
    },
    /**
     * 是否显示图表标题
     */
    showTitle: {
      type: Boolean,
      default: true,
    },
    grid: {
      type: Object,
      default: () => ({
        left: "5%",
        right: "5%",
        top: "25%",
      })
    }
  },
  watch: {
    data() {
      let vm = this;
      if (vm.data.length == 0 || vm.data.length == 1) {
        vm.drawLine();
      } else {
        vm.drawLines();
      }
    },
  },
  data() {
    return {
      id: "",
      myChart: null,
      isShow: false,
      height: 400,
      showTable: false,
      table: {
        columns: [],
        data: [],
        tabData: [],
        type: "noTab",
      },
      radio: "",
    };
  },
  computed: {
    getId() {
      let vm = this;
      vm.id =
        "chart" +
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random()
          .toString()
          .substr(2, 5);
      return vm.id;
    },
  },
  mounted() {
    let vm = this;
    window.addEventListener("resize", () => {
      if (vm.myChart) {
        vm.myChart.resize();
      }
    });
    if (vm.data.length == 0 || vm.data.length == 1) {
      vm.drawLine();
    } else {
      vm.drawLines();
    }
  },
  methods: {
    drawLine() {
      let vm = this;
      vm.showTable = false;
      let pieCharts = document.getElementById(vm.id);
      pieCharts.style.width = this.$refs.pieEcharts.offsetWidth - 34 + "px";
      let myChart = this.$echarts.init(pieCharts);
      let obj = vm.data[0];
      let series = [],
        xAxis = {},
        yAxis = [];
      // 判断是不是不规则的时间
      if (vm.isIrregularity == false) {
        xAxis = {
          boundaryGap: false,
          data: obj.xData,
        };
      } else {
        xAxis = {
          type: "time",
        };
      }
      let markPoint = {
        data: [],
      };
      //添加最大最小值的点
      if (vm.showMaxPoint)
        [markPoint.data.push({ type: "max", name: "最大值" })];
      if (vm.showMinPoint)
        [markPoint.data.push({ type: "min", name: "最小值" })];
      for (let index = 0; index < obj.data.length; index++) {
        let arr = obj.data[index];
        if (vm.isIrregularity == true) {
          for (let j = 0; j < arr.length; j++) {
            arr[j] = {
              value: [obj.xData[j], arr[j]],
            };
          }
        }
        let tempSeries = {
          name: obj.tip[index],
          type: "line",
          data: arr,
          markPoint: markPoint,
          markLine: vm.markLine,
        };
        if (this.activeName == "ele") {
          tempSeries.areaStyle = {
            color: "#1959bf",
            opacity: "0.3",
          };
        }
        if (this.activeName == "zxll") {
          tempSeries.areaStyle = {
            color: "#1959bf",
            opacity: "0.3",
          };
        }
        if (this.activeName == "fxll") {
          tempSeries.areaStyle = {
            color: "#1959bf",
            opacity: "0.3",
          };
        }
        if (this.activeName == "ydl") {
          tempSeries.areaStyle = {
            color: "#1959bf",
            opacity: "0.3",
          };
        }
        if (this.activeName == "sl") {
          tempSeries.areaStyle = {
            color: "#1959bf",
            opacity: "0.3",
          };
        }
        series.push(tempSeries);
      }
      if (vm.myChart == null) {
        vm.myChart = vm.$echarts.init(document.getElementById(vm.id));
      } else {
        vm.myChart.clear();
      }
      // 绘制图表
      vm.myChart.setOption({
        title: {
          text: obj.title.replace(/[\r\n]/g, ""),
          subtext: "查询时间：" + vm.timeTitle.replace(/[\r\n]/g, ""),
          left: "center",
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
            myTool: {
              show: vm.showAddBtn,
              title: "我的工具箱",
              icon: "image:///img/icon-echart.png",
              z: "999",
              left: "center",
              onclick: function() {
                vm.clickoTherAdd();
              },
            },
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: function(opt) {
                if (vm.showTable) {
                  vm.showTable = false;
                } else {
                  vm.optToTableData(opt);
                }
                return null;
              },
            },
          },
        },
        grid: vm.grid,
        legend: {
          data: obj.tip,
          selected: obj.selected,
          left: "center",
          top: "12%",
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        xAxis: xAxis,
        yAxis: [
          {
            name: vm.unit,
            type: "value",
            scale: true,
            max: function(value) {
              let markLineMax = 0;
              let markLine2 = JSON.parse(JSON.stringify(vm.markLine.data));
              if (markLine2.length > 0) {
                markLineMax = markLine2.sort((a, b) => {
                  return Number(a.yAxis) - Number(b.yAxis);
                })[0].yAxis;
              }
              if (value.max > markLineMax) {
                return value.max;
              } else {
                return markLineMax;
              }
            },
            min: function(value) {
              let markLineMin = 0;
              let markLine2 = JSON.parse(JSON.stringify(vm.markLine.data));
              if (markLine2.length > 0) {
                markLineMin = markLine2.sort((a, b) => {
                  return Number(b.yAxis) - Number(a.yAxis);
                })[0].yAxis;
              }
              if (value.min < markLineMin) {
                return value.min;
              } else {
                return markLineMin;
              }
            },
          },
        ],
        series: series,
      });
      vm.isShow = true;
    },
    clickoTherAdd() {
      this.$emit("clickoTherAdd");
    },
    drawLines() {
      let vm = this;
      let data = vm.data;
      //生成图表的grid
      let grid = [],
        xAxis = [],
        yAxis = [],
        series = [],
        title = [],
        obj = data[0];
      document.getElementById(vm.id).style.height = 280 * data.length + "px";
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        let top = 80 + 180 * index + 80 * index;
        grid.push({
          left: "5%",
          right: "5%",
          top: top + "px",
          height: "180px",
        });

        if (vm.isIrregularity == false) {
          xAxis.push({
            gridIndex: index,
            data: data[index].xData,
          });
        } else {
          xAxis.push({
            gridIndex: index,
            type: "time",
          });
        }
        yAxis.push({
          gridIndex: index,
          name: vm.unit,
          type: "value",
          scale: true,
        });
        title.push({
          text: data[index].title.replace(/[\r\n]/g, ""),
          left: "center",
          top: top - 50 + "px",
        });
        for (let j = 0; j < data[index].data.length; j++) {
          const arr = data[index].data[j];

          if (vm.isIrregularity == true) {
            for (let t = 0; t < arr.length; t++) {
              arr[t] = {
                value: [data[index].xData[t], arr[t]],
              };
            }
          }
          series.push({
            xAxisIndex: index,
            yAxisIndex: index,
            name: obj.tip[j],
            type: "line",
            data: arr,
          });
        }
        series.push();
      }

      if (vm.myChart == null) {
        vm.myChart = vm.$echarts.init(document.getElementById(vm.id));
      } else {
        vm.myChart.clear();
      }
      vm.myChart.resize();
      // 绘制图表
      // {
      //     subtext: "查询时间：" + vm.timeTitle,
      //     left: "center"
      //   }
      vm.myChart.setOption({
        title: title,
        tooltip: {
          trigger: "axis",
        },
        grid: grid,
        toolbox: {
          show: true,
          feature: {
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
        },
        legend: {
          data: obj.tip,
          selected: obj.selected,
          x: "center",
          top: "0px",
        },
        // dataZoom: [
        //   {
        //     show: true,
        //     realtime: true
        //   }
        // ],
        xAxis: xAxis,
        yAxis: yAxis,
        series: series,
      });
      vm.isShow = true;
    },

    optToTableData(opt) {
      let vm = this;
      let columns = [];
      let tableData = [];
      let tabData = [];
      let type = "noTabl";
      console.log(opt);
      if (opt.xAxis[0].type == "category") {
        columns.push({ prop: "time", label: "时间" });
        for (let index = 0; index < opt.xAxis[0].data.length; index++) {
          tableData.push({ time: opt.xAxis[0].data[index] });
        }

        for (let index = 0; index < opt.series.length; index++) {
          columns.push({ prop: "td" + index, label: opt.series[index].name });
          for (let j = 0; j < opt.series[index].data.length; j++) {
            tableData[j]["td" + index] = opt.series[index].data[j];
          }
        }
      } else {
        type = "tab";
        columns = [
          { prop: "time", label: "时间" },
          { prop: "value", label: "值" },
        ];
        for (let index = 0; index < opt.series.length; index++) {
          if (index === 0) {
            vm.radio = opt.series[index].name;
          }
          let item = {
            label: opt.series[index].name,
            data: [],
          };
          tabData.push(opt.series[index].name);

          for (let j = 0; j < opt.series[index].data.length; j++) {
            item.data.push({
              time: opt.series[index].data[j].value[0],
              value: opt.series[index].data[j].value[1],
            });
          }
          tableData[opt.series[index].name] = item;
        }
      }

      vm.table = {
        columns: columns,
        data: tableData,
        type: type,
        tabData: tabData,
      };
      vm.showTable = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.echarts-warp {
  width: 100%;
  padding: 14px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #dedcdc;
}
.echart-content {
  border-radius: 5px;
  border: 1px solid #dedcdc;
  overflow: hidden;
  position: relative;
}
.echarts-title {
  height: 34px;
  line-height: 34px;
  padding-left: 14px;
  color: #fff;
  background: #1d6ce9;
}
.iconlocal {
  position: absolute;
  top: 40px;
  right: 110px;
  z-index: 999;
  i {
    cursor: pointer;
  }
}
.iconlocal:hover {
  cursor: pointer;
  color: #1d6ce9;
}
.chartbox {
  position: absolute;
  top: 35px;
}
.table-wrap {
  position: absolute;
  top: 80px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  flex-flow: column;
  .table-content {
    flex: 1;
    overflow: auto;
  }
}
</style>
